/** Performs a real browser request without reading from or writing to HTTP cache. */
export const fetchFresh: typeof fetch = (input, init) =>
  globalThis.fetch(input, {
    ...init,
    cache: "no-store"
  })
